import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaCode,
  FaPalette,
  FaMobile,
  FaChartLine,
  FaLaptop,
  FaPaintBrush,
  FaBuilding,
  FaSearch,
  FaMoneyBill,
  FaCalendar,
} from "react-icons/fa";
import "./Styles/Service.css";
import IntlMessages from "../../intl/IntlMessages";
import { useIntl } from "react-intl";

const ServicesPage = () => {
  const navigate = useNavigate();
  const [activeProcess, setActiveProcess] = useState(0);
  const intl = useIntl();

  const services = [
    {
      icon: <FaCode />,
      title: <IntlMessages id="servicesPage.service1.title" />,
      description: <IntlMessages id="servicesPage.service1.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "30 000 FCFA",
      priceUSD: "$51",
      details: [
        <IntlMessages id="servicesPage.service1.details1" />,
        <IntlMessages id="servicesPage.service1.details2" />,
        <IntlMessages id="servicesPage.service1.details3" />,
        <IntlMessages id="servicesPage.service1.details4" />,
        <IntlMessages id="servicesPage.service1.details5" />,
        <IntlMessages id="servicesPage.service1.details6" />,
        <IntlMessages id="servicesPage.service1.details7" />,
      ],
    },
    {
      icon: <FaMobile />,
      title: <IntlMessages id="servicesPage.service3.title" />,
      description: <IntlMessages id="servicesPage.service3.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "200 000 FCFA",
      priceUSD: "$340",
      details: [
        <IntlMessages id="servicesPage.service3.details1" />,
        <IntlMessages id="servicesPage.service3.details2" />,
        <IntlMessages id="servicesPage.service3.details3" />,
        <IntlMessages id="servicesPage.service3.details4" />,
      ],
    },
    {
      icon: <FaLaptop />,
      title: <IntlMessages id="servicesPage.service4.title" />,
      description: <IntlMessages id="servicesPage.service4.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "200 000 FCFA",
      priceUSD: "$340",
      details: [
        <IntlMessages id="servicesPage.service4.details1" />,
        <IntlMessages id="servicesPage.service4.details2" />,
      ],
    },
    {
      icon: <FaPaintBrush />,
      title: <IntlMessages id="servicesPage.service5.title" />,
      description: <IntlMessages id="servicesPage.service5.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "5 000 FCFA",
      priceUSD: "$8,5",
      details: [
        <IntlMessages id="servicesPage.service5.details1" />,
        <IntlMessages id="servicesPage.service5.details2" />,
        <IntlMessages id="servicesPage.service5.details3" />,
        <IntlMessages id="servicesPage.service5.details4" />,
        <IntlMessages id="servicesPage.service5.details5" />,
        <IntlMessages id="servicesPage.service2.details2" />,
        <IntlMessages id="servicesPage.service2.details3" />,
        <IntlMessages id="servicesPage.service2.details4" />,
      ],
    },
    {
      icon: <FaBuilding />,
      title: <IntlMessages id="servicesPage.service6.title" />,
      description: <IntlMessages id="servicesPage.service6.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "100 000 FCFA",
      priceUSD: "$170",
      details: [
        <IntlMessages id="servicesPage.service6.details1" />,
        <IntlMessages id="servicesPage.service6.details2" />,
        <IntlMessages id="servicesPage.service6.details3" />,
        <IntlMessages id="servicesPage.service6.details4" />,
        <IntlMessages id="servicesPage.service6.details5" />,
        <IntlMessages id="servicesPage.service6.details6" />,
        <IntlMessages id="servicesPage.service6.details7" />,
      ],
    },
    {
      icon: <FaMoneyBill />,
      title: <IntlMessages id="servicesPage.service7.title" />,
      description: <IntlMessages id="servicesPage.service7.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "5 000 FCFA",
      priceUSD: "$8,5",
      details: [
        <IntlMessages id="servicesPage.service7.details1" />,
        <IntlMessages id="servicesPage.service7.details2" />,
        <IntlMessages id="servicesPage.service7.details3" />,
        <IntlMessages id="servicesPage.service7.details4" />,
      ],
    },
    {
      icon: <FaChartLine />,
      title: <IntlMessages id="servicesPage.service8.title" />,
      description: <IntlMessages id="servicesPage.service8.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "500 000 FCFA",
      priceUSD: "$850",
      details: [
        <IntlMessages id="servicesPage.service8.details1" />,
        <IntlMessages id="servicesPage.service8.details2" />,
        <IntlMessages id="servicesPage.service8.details3" />,
        <IntlMessages id="servicesPage.service8.details4" />,
        <IntlMessages id="servicesPage.service8.details5" />,
        <IntlMessages id="servicesPage.service8.details6" />,
      ],
    },
    {
      icon: <FaSearch />,
      title: <IntlMessages id="servicesPage.service9.title" />,
      description: <IntlMessages id="servicesPage.service9.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "5 000 FCFA",
      priceUSD: "$8,5",
      details: [
        <IntlMessages id="servicesPage.service9.details1" />,
        <IntlMessages id="servicesPage.service9.details2" />,
        <IntlMessages id="servicesPage.service9.details3" />,
        <IntlMessages id="servicesPage.service9.details4" />,
        <IntlMessages id="servicesPage.service9.details5" />,
        <IntlMessages id="servicesPage.service9.details6" />,
        <IntlMessages id="servicesPage.service9.details7" />,
        <IntlMessages id="servicesPage.service9.details8" />,
      ],
    },
    {
      icon: <FaCalendar />,
      title: <IntlMessages id="servicesPage.service10.title" />,
      description: <IntlMessages id="servicesPage.service10.description" />,
      textContain: intl.formatMessage({ id: "textContain.beforePrice" }),
      priceFCFA: "250 000 FCFA",
      priceUSD: "$588",
      details: [
        <IntlMessages id="servicesPage.service10.details1" />,
        <IntlMessages id="servicesPage.service10.details2" />,
        <IntlMessages id="servicesPage.service10.details3" />,
        <IntlMessages id="servicesPage.service10.details4" />,
        <IntlMessages id="servicesPage.service10.details5" />,
        <IntlMessages id="servicesPage.service10.details6" />,
        <IntlMessages id="servicesPage.service10.details7" />,
        <IntlMessages id="servicesPage.service10.details8" />,
      ],
    },
  ];

  const process = [
    {
      title: <IntlMessages id="servicesPage.process1.title" />,
      description: <IntlMessages id="servicesPage.process1.description" />,
      steps: [
        <IntlMessages id="servicesPage.process1.steps1" />,
        <IntlMessages id="servicesPage.process1.steps2" />,
        <IntlMessages id="servicesPage.process1.steps3" />,
      ],
    },
    {
      title: <IntlMessages id="servicesPage.process2.title" />,
      description: <IntlMessages id="servicesPage.process2.description" />,
      steps: [
        <IntlMessages id="servicesPage.process2.steps1" />,
        <IntlMessages id="servicesPage.process2.steps2" />,
        <IntlMessages id="servicesPage.process2.steps3" />,
      ],
    },
    {
      title: <IntlMessages id="servicesPage.process4.title" />,
      description: <IntlMessages id="servicesPage.process4.description" />,
      steps: [
        <IntlMessages id="servicesPage.process1.steps1" />,
        <IntlMessages id="servicesPage.process1.steps2" />,
        <IntlMessages id="servicesPage.process1.steps3" />,
      ],
    },
    {
      title: <IntlMessages id="servicesPage.process4.title" />,
      description: <IntlMessages id="servicesPage.process4.description" />,
      steps: [
        <IntlMessages id="servicesPage.process4.steps1" />,
        <IntlMessages id="servicesPage.process4.steps2" />,
      ],
    },
  ];

  const handleInterested = () => {
    navigate("/contact", { state: { fromServices: true } });
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <div className="services-hero2">
        <div className="services-hero">
          <h1><IntlMessages id="servicesPage.heroTitle" /></h1>
          <p><IntlMessages id="servicesPage.heroSubtitle" /></p>
          <p className="marge-note"><IntlMessages id="navigation.otherServices" /></p>
        </div>
      </div>

      {/* Services Grid */}
      <section className="services-grid">
        {services.map((service, index) => (
          <div className="services-card" key={index}>
            <div className="services-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <p className="service-price">{`${service.textContain} - ${service.priceFCFA} | ${service.priceUSD}`}</p>
            <ul className="services-details">
              {service.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
            <button className="interested-btn" onClick={handleInterested}>
              <IntlMessages id="interest.interested" />
            </button>
          </div>
        ))}
      </section>

      {/* Process Section */}
      <section className="process-section">
        <h2>
          <IntlMessages id="process.ourProcess" />
        </h2>
        <div className="process-timeline">
          {process.map((step, index) => (
            <div
              className={`process-step ${
                activeProcess === index ? "active" : ""
              }`}
              key={index}
              onMouseEnter={() => setActiveProcess(index)}
            >
              <div className="process-number">{index + 1}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <ul className="process-details">
                {step.steps.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="ctaa-section">
        <h2><IntlMessages id="servicesPage.ctaaTitle" /></h2>
        <p><IntlMessages id="servicesPage.ctaaDescription" /></p>
        <button className="ctaa-button" onClick={handleInterested}>
          <IntlMessages id="content.getInTouch" />
        </button>
      </section>
    </div>
  );
};

export default ServicesPage;
